<template>
<div class="user">
  <el-tabs type="border-card" :tab-position="tabPosition" style="height: 550px;min-height: 550px;">
    <el-tab-pane label="个人信息" style="width:480px;">
      <div id="ch-display">
        <div><span>用户名：</span><span>{{change.username}}</span></div>
        <div><span>电话号码：</span><span>{{change.telephone}}</span></div>
        <div><span>邮箱：</span><span>{{change.email}}</span></div>
        <div><span>账户类型：</span><span>{{change.userType}}</span></div>
        <div><span>性别：</span><span>{{change.gender}}</span></div>
        <div><span>可导个数：</span><span>{{change.derivedNumber}}</span></div>
        <div><span>个人简介：</span><span>{{change.description}}</span></div>
      </div>
    </el-tab-pane>

    <el-tab-pane label="更新信息" style="width:450px;" v-loading="loading">
      <div id="ch-update">
        <el-form ref="form" :model="change" label-width="180px" class="updataForm" :label-position="labelPosition">
          <el-form-item label="用户名：" class="inputBox" label-width="40%">
            <el-input placeholder="请输入用户名" v-model="change.username"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" class="inputBox" label-width="40%">
            <el-input placeholder="请输入电话号码" v-model="change.telephone" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="邮箱：" class="inputBox" label-width="40%">
            <el-input placeholder="请输入邮箱" v-model="change.email"></el-input>
          </el-form-item>
          <el-form-item label="账户类型：" class="inputBox" label-width="40%">
            <el-input placeholder="请输入账户类型" v-model="change.userType" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="性别：" prop="gender" class="inputBox" label-width="40%">
            <el-radio v-model="radio" label="1">男</el-radio>
            <el-radio v-model="radio" label="2">女</el-radio>
          </el-form-item>

          <el-form-item label="可导个数：" class="inputBox" label-width="40%">
            <el-input placeholder="请输入内容" v-model="change.derivedNumber" ></el-input>
          </el-form-item>

          <el-form-item label="个人简介：" class="inputBox" label-width="40%">
            <el-input :maxlength="100" type="textarea" resize="none" placeholder="字数限制（100）" v-model="change.description"></el-input>
          </el-form-item>
        </el-form>
        <div class="upPasswordButtonDiv">
          <div>
            <el-button class="upPasswordButton1" @click="changeUser">提交信息</el-button>
            <el-button class="upPasswordButton2" @click="reset">重置输入</el-button>
          </div>
        </div>
      </div>
    </el-tab-pane>


    <el-tab-pane label="修改密码" style="width:480px" v-loading="loading">
      <div class="upPassword">
        <div>
          <el-input placeholder="请输入旧密码" v-model="oldPassword" show-password class="inputBox2"></el-input>
          <span>旧密码：</span>
        </div>
        <div>
          <el-input placeholder="请输入新密码" v-model="newPassword" show-password class="inputBox2"></el-input>
          <span>新密码：</span>
        </div>
        <div>
          <el-input placeholder="请输入确认密码" v-model="surePassword" show-password class="inputBox2"></el-input>
          <span>确认密码：</span>
        </div>
      </div>
      <div class="upPasswordButtonDiv">
        <div>
          <el-button class="upPasswordButton1" @click="changePassword">确认修改</el-button>
          <el-button class="upPasswordButton2" @click="clear">重置输入</el-button>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>

</div>
</template>


<script>
export default {
  name: "personIfo",
  data() {
    return {
      /*加载动画*/
      loading: false,

      labelPosition: 'right',
      tabPosition: 'left',
      change: {
        id: '',
        username: '',
        telephone: '',
        email: '',
        gender: '',
        description: '',
        derivedNumber: '',
        userType: '',
      },
      oldPassword: '',
      newPassword: '',
      surePassword: '',
      item: 'one',
      radio: '',
    };
  },
  methods: {
    changeUser() {
      let {
        username,
        description,
        email
      } = this.change;
      let gender = (this.radio === '1') ? 1 : ((this.radio === '2') ? 2 : 0);
      let formData = JSON.stringify({
        username,
        gender,
        description,
        email
      });
      this.loading = true;
      this.$http.put(
          '/user/info',
          formData, {
            headers: {
              'Content-Type': 'application/json'
            },
            withCredentials: true
          }
        ).then((response) => {
          this.$message({
            message: "修改成功",
            type: 'success',
            center: true,
            duration: 1500
          });
          this.dialogEdittVisible = false;
          this.$nextTick(
            this.loading = false,
          );
        })
        .catch((error) => {
          this.$nextTick(
            this.loading = false,
          );
        });
    },
    changePassword() {
      if (this.newPassword !== this.surePassword) {
        this.$message({
          message: "两次输入的密码不一致",
          type: 'error',
          center: true,
          duration: 1500
        })
      } else {
        let postData = {
          password: this.oldPassword,
          modifiedPassword: this.newPassword,
        };
        postData = JSON.stringify(postData);
        this.loading = true;
        this.$http.put(
            '/user/password',
            postData, {
              headers: {
                'Content-Type': 'application/json'
              },
              withCredentials: true
            }
          )
          .then((res) => {
            this.$message({
              message: "修改成功",
              type: 'success',
              center: true,
              duration: 1500
            });
            this.clear();
            this.$nextTick(
              this.loading = false,
            );
          })
          .catch((err) => {
            this.$nextTick(
              this.loading = false,
            );
          })
      }
    },
    clear() {
      this.oldPassword = '';
      this.newPassword = '';
      this.surePassword = '';
    },
    reset() {
      this.change.username = '';
      this.change.email = '';
      this.change.description = '';
    },
  },
  mounted() {
    let id = localStorage.id;
    this.$http.get(
        '/user/' + id, {
          withCredentials: true
        }
      )
      .then((res) => {
        let {
          change
        } = this;
        for (let key of Object.keys(res)) {
          if (key === "id" || key === "username" || key === "telephone" || key === 'email' || key === 'description' || key === 'derivedNumber') {
            change[key] = res[key];
          }
        }
        change.gender = (res.gender === 1) ? "男" : ((res.gender === 2) ? "女" : "");
        this.radio = (res.gender === 1) ? '1' : ((res.gender === 2) ? '2' : '3');
        change.userType = (res.userRole.roleId == 1) ? "超级管理员" : ((res.userRole.roleId == 2) ? "数据采集员" : "普通用户");
      })
      .catch((err) => {
        console.log(err);
      })
  }
};
</script>

<style>
/* 解决nginx的显示问题 */
.user .el-tabs {
  display: flex !important;
}

/*个人信息页面div布局*/
#ch-display>div {
  height: 50px;
  border-bottom: 1px solid #cccccc;
  line-height: 65px;
  padding-left: 30% !important;
  font-size: 16px;
  width: 100% !important;
}

/*更新信息页面每行信息样式*/
.inputBox {
  margin: 0 auto !important;
  margin-top: 20px !important;
  width: 70% !important;
}

/*修改密码页面每行的布局*/
.upPassword>div {
  margin-top: 25px;
  display: flex !important;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: right;
  margin-right: 25% !important;
}

/*修改密码页面输入框的宽度*/
.inputBox2 {
  width: 60% !important;
}

/*更新信息及修改密码页面按钮外层包裹div*/
.upPasswordButtonDiv {
  border-top: 1px solid #cccccc;
  padding-top: 15px !important;
  margin-top: 15px;
}

/*更新信息及修改密码页面按钮内层包裹div，按钮的布局*/
.upPasswordButtonDiv>div {
  width: 70% !important;
  display: flex !important;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin: 0 auto;
}

/*更新信息及修改密码页面确认按钮样式*/
.upPasswordButton1 {
  background-color: #409EFF;
  color: white;
}

/*更新信息及修改密码页面清空按钮样式*/
.upPasswordButton2 {
  background-color: #E6A23C;
  color: white;
}

/*弹窗样式*/
.user .el-dialog {
  width: 45% !important;
  overflow: hidden !important;
  min-width: 650px !important;
  min-height: 670px !important;
  max-height: 2000px !important;
}

/*update*/
/*解决字数过多溢出问题*/
.over {
  line-height: 1.3;
}
</style>



// WEBPACK FOOTER //
// src/user/personIfo.vue